import React from "react";

export default function AutoCarousel({ children, title }) {
  const items = React.Children.toArray(children);

  return (
    <React.Fragment>
      {title && (
        <div className="sf-section-header">
          <h2 className="sf-section-title">{title}</h2>
        </div>
      )}
      <div className="sf-carousel-wrapper">
        <div className="sf-carousel-track">
          {items}
          {items}
        </div>
      </div>
    </React.Fragment>
  );
}
